module.exports = __webpack_public_path__ + "img/symbol_amor.193de35.jpg";